import { Chip, Typography } from '@mui/material';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import { styled } from '@mui/material/styles';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import PauseCircleFilledRoundedIcon from '@mui/icons-material/PauseCircleFilledRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    const date = typeof d === 'string' ? new Date(d) : d;
    return new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: '2-digit' }).format(date);
  } catch {
    return d;
  }
};

export const statusMeta = {
  COMPLETED: { label: 'Active', color: 'success', icon: <CheckCircleRoundedIcon fontSize="small" /> },
  PENDING: { label: 'Pending', color: 'warning', icon: <PauseCircleFilledRoundedIcon fontSize="small" /> },
  Active: { label: 'Active', color: 'success', icon: <CheckCircleRoundedIcon fontSize="small" /> },
  Inactive: { label: 'Inactive', color: 'error', icon: <CancelRoundedIcon fontSize="small" /> },
};

export const StatusChip = ({ value }) => {
  const meta = statusMeta[value] || { color: 'default', icon: null };
  return (
    <Chip
      size="small"
      icon={meta.icon}
      label={meta.label}
      color={meta.color}
      variant="outlined"
      sx={{ borderRadius: 1 }}
    />
  );
};

export const DetailRow = ({ label, value }) => (
  <div className="flex items-start justify-between gap-4 py-1">
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="body2" fontWeight={600} color="text.primary" textAlign="right">
      {value || '—'}
    </Typography>
  </div>
);

export const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: '100%',
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: 1.5,
  padding: '12px',
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxSizing: 'border-box',
  resize:
    'none', // keep auto-size only
    '&:hover': {
      borderColor: theme.palette.text.primary,
    },
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}33`, // subtle focus ring
    },
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
}));